<template>
  <v-combobox
    :value="facilityId"
    :search-input.sync="search"
    cache-items
    :items="facilities"
    :loading="loading"
    @input="chooseFacility"
    :filter="customFilter"
    v-bind="$attrs"
    placeholder="Add a facility..."
  >
    <template v-slot:prepend>
      <slot name="prepend"></slot>
    </template>
    <template v-slot:default>
      <slot></slot>
    </template>
    <template v-slot:append>
      <slot name="append"></slot>
    </template>
    <template v-slot:append-outer>
      <slot name="append-outer"></slot>
    </template>
  </v-combobox>
</template>

<script>
import { debounce } from "lodash";
export default {
  name: "HpiFacilitySearch",
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: ""
    }
  },
  data() {
    return {
      search: "",
      facilityId: "",
      facilities: [],
      loading: false,
      selectedFacility: {}
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: "getFacility"
    },
    search: "searchFacilities"
  },
  methods: {
    async getFacility(facilityId) {
      this.facilityId = facilityId;
      this.loading = true;
      try {
        let res = await this.$http.get(`hpifacilities/${facilityId}`);
        if (res.data.id) {
          this.facilities = [this.transformFac(res.data)];
          this.search = res.data.name;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    searchFacilities: debounce(async function(search) {
      if (!search || search.length < 3) {
        return;
      }
      this.loading = true;
      try {
        let keywordsearch = search
          .split(" ")
          .filter(s => s)
          .map(word => {
            return {
              or: [
                { name: { like: `%${word}%` } },
                { hpifacilityid: { like: `%${word}%` } }
              ]
            };
          });
        let where = { and: keywordsearch };

        let res = await this.$http.get("hpifacilities", {
          params: {
            filter: { limit: 100, where }
          }
        });
        if (Array.isArray(res.data)) {
          this.facilities = res.data.map(this.transformFac);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    }, 300),
    chooseFacility(option) {
      console.debug("HPIFacilitySearch chose option: ", option);
      if (typeof option === "string") {
        this.$emit("input", option);
        // this.search = option;
      } else {
        this.$emit("input", option.value);
        // this.search = option.text;
      }
    },
    transformFac(fac) {
      return { value: fac.hpifacilityid, text: fac.name, object: fac };
    },
    customFilter(item, queryText, itemText) {
      if (!queryText || queryText.length < 3) {
        return false;
      }
      let keywords = queryText
        .toLowerCase()
        .split(" ")
        .filter(s => s);
      let matches = keywords.filter(
        word =>
          item.text.toLowerCase().includes(word) ||
          item.value.toLowerCase().includes(word)
      );
      return keywords.length == matches.length;
    }
  }
};
</script>
